import { QUANTITY_DEFINITION_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

const stepUrl = code => `${QUANTITY_DEFINITION_API}${encodeURIComponent(code)}/commission-step/`;
const adjustmentUrl = code => `${QUANTITY_DEFINITION_API}${encodeURIComponent(code)}/commission-adjustments/`;

export const getCommissionStep = code => axiosHttp.get(stepUrl(code));
export const createCommissionStep = (code, data) => axiosHttp.post(stepUrl(code), data);
export const updateCommissionStep = (code, data) => axiosHttp.patch(stepUrl(code), data);
export const applyCommissionAdjustment = (code, data) => axiosHttp.post(adjustmentUrl(code), data);
